import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLockOpen32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.268 6.14c.402-.482 1.112-.795 1.922-.97a8 8 0 0 1 1.71-.172h.035l.15.002C18.8 5 21 7.2 21 9.914V11H9a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4V9.914A6.914 6.914 0 0 0 15.981 3l-.05-.001a10 10 0 0 0-2.165.217c-.963.208-2.205.65-3.034 1.645-.4.48-.65.826-.806 1.065a4 4 0 0 0-.223.386l-.017.038-.007.016-.003.008-.002.004v.002c-.001.001-.001.001.926.376l-.927-.375a1 1 0 0 0 1.84.785l.001-.004q.013-.027.088-.145c.104-.16.304-.441.666-.876m4.7 14.61a2 2 0 1 0-1.937 0q-.03.12-.031.25v1a1 1 0 1 0 2 0v-1q0-.13-.031-.25"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen32Filled);
